import Vue from 'vue'
import {
  extend,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate'
import {
  email,
  max,
  min,
  regex,
  numeric,
  required,
  ext,
} from 'vee-validate/dist/rules'

extend('email', {
  ...email,
  message: '{_field_} muss eine gültige E-Mail-Adresse sein',
})
extend('ext', ext)
extend('max', max)
extend('min', min)
extend('numeric', numeric)
extend('regex', {
  ...regex,
  message: 'Ungültige Handynummer, nur Nummern, + und - Symbol zulassen',
})
extend('numeric', {
  ...numeric,
  message: '{_field_} ist ungültig',
})
extend('required', {
  ...required,
  message: '{_field_} ist ein Pflichtfeld',
})

Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)
